import LoadingIcon from "../../common/LoadingIcon";
import DataTable from "../../common/DataTable";
import Button from "../../common/Button";
import { useBoardFromContext } from "../../../utils/hooks/commonly-stored/uploaded-board/board";
import { Board } from "../../../reducers/uploadedBoard";
import {
  useDownloadPickAndPlaceFiles,
  usePickAndPlaceData,
} from "../../../utils/hooks/commonly-stored/uploaded-board/pickAndPlaceFiles";

export default function ViewAndDownloadPlacements() {
  const board = useBoardFromContext().board as Board;
  const downloadPickAndPlaceFiles = useDownloadPickAndPlaceFiles();
  const { pickAndPlaceData, loading } = usePickAndPlaceData(board.id);

  if (pickAndPlaceData === undefined || loading) {
    return <LoadingIcon text={"Loading pnp data"} />;
  }

  return (
    <>
      <Button
        label={"Download PnP files"}
        styleProps={{ margin: 10 }}
        onClick={(): void => {
          downloadPickAndPlaceFiles(board.id, board.project_name);
        }}
      />
      <DataTable table={pickAndPlaceData.top} />
      <DataTable table={pickAndPlaceData.bottom} />
    </>
  );
}
